module.exports = __webpack_public_path__ + "static/media/right.c3fe7f18.svg";